import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { EXPERIMENT_ROUTES, OLD_EXPERIMENT_ROUTES } from "../../routes";

export const ExperimentRoutes: RouteObject[] = [
  {
    path: EXPERIMENT_ROUTES.Experiments,
    lazy: async () => {
      const { ExperiencesHomeRoute } = await import(
        "@src/features/experiments/pages/home/ExperiencesHome.route"
      );
      return { element: <ExperiencesHomeRoute /> };
    },
  },
];
